import gCard from "@/components/g-card/g-card.vue";
import gForm from "@/components/g-form/g-form.vue";
import gDateInput from "@/components/g-date-input/g-date-input.vue";
import gButton from "@/components/g-button/g-button.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import FiltroCartaPropostaAguardandoAprovacao from "@/shared/view-models/Filtros/FiltroCartaPropostaAguardandoAprovacao.js";
import CartaPropostaController from "@/shared/controllers/cartaProposta/CartaPropostaController";
import { defineComponent } from "vue";
import EVENTS from "@/shared/events/events";

const name = "AguardandoAprovacao";
export default defineComponent({
  name,

  components: {
    "g-card": gCard,
    "g-form": gForm,
    "g-date-input": gDateInput,
    "g-button": gButton,
    "g-data-table": gDataTable,
  },

  props: {},

  mounted() {
    this.getClientes(),
    this.getEmpresa(),
    this.populateTipoCarta(),
    this.getStatusSolicitacao();
    this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;

    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.OrcamentoArray = null
    })
  },

  updated() {},

  data() {
    return {
      gerarCartaPropostaPopup: false,
      CartaPropostaSelecionada: "",
      colunasOrcamentosDigitacao: null,
      LinhaProdutoArray: [],
      CidadeSelecionada: {},
      dataProduto: null,

      EmpresaSelecionada: null,

      ClienteSelecionado: null,

      OrcamentoSelecionado: null,
      OrcamentoArray: [],
      popup: false,

      redirecionarParaOrcamento: false,
      mensagemvazio: true,
      informacaoOrcamentoSelecionado: null,

      dataClientes: [],
      EmpresaArray: [],
      statusSolicitacaoArray: [],
      produtoArray: [],
      OrcamentoProdutoArray: [],

      formSearch: new FiltroCartaPropostaAguardandoAprovacao(),
      cartaArray: [],
      Colunas: [
        //Campo dos dados , nome que aparece na página
        { field: "numeroCartaProposta", header: "N° Carta-Proposta", width: '50px', ordena: true },
        { field: "statusSolicitacaoText", header: "Status da Solicitacao", width: '100px', ordena: true },
        { field: "tipoCartaText", header: "Tipo de Carta", width: '100px', ordena: true },
        { field: "nomeFantasia", header: "Cliente", width: '250px', ordena: true },
        { field: "tipoSolicitacao", header: "Tipo da Solicitação", width: '250px', ordena: true },
        { field: "dataInclusaoFormatada", header: "Dt. Digitação", width: '200px', ordena: true, ordenacao: 'dataInclusaoFormatada' },
        { field: "dataAlteracaoFormatada", header: "Última Atualização", width: '200px', ordena: true, ordenacao: 'dataAlteracaoFormatada' }, //RENOMEAR ISSO AQUI
        { field: "nomeEmpresa", header: "Empresa", width: '250px', ordena: true },
        { field: "nomeRepresentante", header: "Representante", width: '250px', ordena: true },
      ],
      Filtro: {
        global: { value: null, matchMode: this.filtros.CONTAINS }, //permite buscar por colunas específicas
        numeroCartaProposta: { value: null, matchMode: this.filtros.CONTAINS },
        nomeFantasia: { value: null, matchMode: this.filtros.CONTAINS },
        dataDigitacaoFormatada: {
          value: null,
          matchMode: this.filtros.CONTAINS,
        },
        tipoCartaText: { value: null, matchMode: this.filtros.CONTAINS },
        nomeEmpresa: { value: null, matchMode: this.filtros.CONTAINS },
        nomeRepresentante: { value: null, matchMode: this.filtros.CONTAINS },
        dataAlteracaoFormatada: {
          value: null,
          matchMode: this.filtros.CONTAINS,
        },
        statusSolicitacaoText: {
          value: null,
          matchMode: this.filtros.CONTAINS,
        },
      },
      MotivoReprovaPopup: false,
      MotivoAprovaPopup: false,
      motivoReprova: "",
      statusSolicitacaoClicado: "",
      AutorizaPrecoBool: false,
      AutorizaPrazoBool: false,
      tipoSolicitacao: "",
      timer: null,
    };
  },

  methods: {
    populateTipoCarta() {
      this.axios({
        method: "get",
        url: process.env.VUE_APP_WEB_API + "CartaProposta/GetTipoCartaEnum",
      })
        .then((response) => {
          this.cartaArray = response.data;
        })
        .catch(() => {});
    },
    buscar() {
      (this.mensagemvazio = false), this.$isLoading(true);
      this.axios({
        method: "post",
        data: this.formSearch,
        url:
          process.env.VUE_APP_WEB_API +
          "CartaProposta/GetCartasPropostaAguardandoAprovacaoByFiltro",
      }).then((response) => {
        this.OrcamentoArray = response.data.data;
        this.$isLoading(false);
      });
    },
    clear() {
      Object.keys(this.formSearch).forEach((Element) => {
        this.formSearch[Element] = null;
      });
    },
    redirecionarAprovado() {
      //verifica se é uma solicitacao de prazo ou de preço
      if (this.AutorizaPrazoBool == true) {
        this.$router.push(
          `/gerar-carta-proposta/${this.CartaPropostaSelecionada}/pagamento`
        );
      } else if (this.AutorizaPrecoBool == true) {
        this.$router.push(
          `/gerar-carta-proposta/${this.CartaPropostaSelecionada}/markup`
        );
      }
    },
    fechaPopup() {
      this.popup = false;
    },
    getClientes() {
      ClienteController.getClientes()
        .requisicao.then((Response) => {
          this.dataClientes = Response.data.data;
        })
        .catch(() => {
        });
    },
    getEmpresa() {
      this.EmpresaArray = this.$store.state.EmpresaArray;
    },
    getStatusSolicitacao() {
      CartaPropostaController.GetStatusSituacaoCartaPropostaEnum()
        .requisicao.then((Response) => {
          this.statusSolicitacaoArray = Response.data;
          this.statusSolicitacaoArray.push({
            text: "Aguardando Aprovação",
            value: 10,
            enum: null,
          });
        })
        .catch((Error) => {
          console.error(Error);
        });
    },
    buscarClientes(event) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.dataClientes =
          ClienteController.getClienteDropDownsByNome(event, this.formSearch.EmpresaId, this.formSearch.RepresentanteId).ClientesArray;
      }, 1000);
    },
    verificaStatus (informacaoDaLinha) {
      this.CartaPropostaSelecionada = informacaoDaLinha.id;

      if(informacaoDaLinha.statusSolicitacao == 0 || informacaoDaLinha.statusSolicitacao == 2 ) //se foi aprovada ou parcialmente aprovada abre popup pra confirmar que vai enviar pra cartaproposta
      {
        //this.statusSolicitacaoClicado = informacaoDaLinha.statusSolicitacao
        this.MotivoReprovaPopup = false
        this.MotivoAprovaPopup = true
        this.AutorizaPrazoBool = informacaoDaLinha.autorizaPrazoBool
        this.AutorizaPrecoBool = informacaoDaLinha.autorizaPrecoBool
      }
      else if (informacaoDaLinha.statusSolicitacao == 1 ) //se foi reprovado abre popup com a mensagem de motivo da reprova
      {
        this.MotivoAprovaPopup = false
        this.MotivoReprovaPopup = true
        this.motivoReprova = informacaoDaLinha.motivoReprova
      }

    },
      atualizaEmpresaRepresentante(){
        this.formSearch.EmpresasIds = this.$store.state.empresaSelecionadaId;
      },
  },
  computed: {},
});

